import { attachClickTracker } from "../native-helpers";
// "Kalapuikko"
const simaRectangle = {
    name: "sima_rectangle",
    buildContent: (adObj, wrapperId) => {
        const { native } = adObj;
        let nativeContent = "";
        const title = native.title ?? "";
        const sponsoredBy = native.sponsoredBy ?? "";
        const imageUrl = native.image?.url;
        nativeContent +=
            `<div id="${wrapperId}">` +
                `	<div id="${wrapperId}_content_wrapper" class="${wrapperId}_sizing">` +
                `		<div id="${wrapperId}_img_wrapper">` +
                `  		<img src="${imageUrl}" id="${wrapperId}_img">` +
                `  	</div>` +
                `		<div id="${wrapperId}_right_container">` +
                `  		<div id="${wrapperId}_sponsored_by_wrapper">` +
                `    		<span id="${wrapperId}_sponsored">Kaupallinen yhteistyö:</span>` +
                `    		<span id="${wrapperId}_sponsored_by">${sponsoredBy}</span>` +
                `			</div>` +
                `  		<div id="${wrapperId}_text">` +
                `  			<div id="${wrapperId}_title">${title}</div>` +
                `			</div>` +
                ` 	</div>` +
                `	</div>` +
                `</div>`;
        return nativeContent;
    },
    buildStyles: (wrapperId) => {
        const isLongform = (window?.digitalData?.page?.category?.tags ?? []).includes("longform");
        let nativeCss = "";
        const primaryCategory = window?.digitalData?.page?.category?.primaryCategory ?? "";
        const longformSharedStyles = `@font-face{font-family:BerninoSansNarrowSemibold;src:url(https://assets.ilcdn.fi/BerninoSans-Web-NarrowSemibold.woff2) format("woff2"),url(https://assets.ilcdn.fi/BerninoSans-Web-NarrowSemibold.woff) format("woff"),url(https://assets.ilcdn.fi/BerninoSans-Web-NarrowSemibold.ttf) format("ttf"),url(https://assets.ilcdn.fi/BerninoSans-Web-NarrowSemibold.eot) format("eot")}@font-face{font-family:BerninoSansNarrowBold;src:url(https://assets.ilcdn.fi/BerninoSans-Web-NarrowBold.woff2) format("woff2"),url(https://assets.ilcdn.fi/BerninoSans-Web-NarrowBold.woff) format("woff")}#${wrapperId}{font-family:BerninoSansNarrowSemibold;cursor:pointer;clear:both}#${wrapperId}_content_wrapper{width:100%;background-color:#fff1f1}.${wrapperId}_sizing{box-sizing:border-box;display:flex}#${wrapperId}_img_wrapper{max-width:95px;max-height:95px;margin:7px;flex:6;overflow:hidden;padding-bottom:95px;position:relative}#${wrapperId}_img{width:100%;height:95px;left:-35px;min-width:180%;position:absolute}#${wrapperId}_right_container{flex:14;min-width:0}#${wrapperId}_sponsored_by_wrapper{font-family:BerninoSansNarrowBold;font-size:11px;color:red;min-height:20px;padding:0 7px 0 0;margin-top:10px;text-transform:uppercase;line-height:13px}#${wrapperId}_text{font-family:BerninoSansNarrowSemibold;word-wrap:break-word;padding:7px 7px 3px 0;text-decoration:none;font-size:16px;line-height:18px}@media only screen and (min-width:768px){#${wrapperId}{width:600px;margin:0 auto 14px}#${wrapperId}_img_wrapper{max-width:120px;max-height:120px;padding-bottom:120px}#${wrapperId}_img{width:100%;height:120px;left:-45px}#${wrapperId}_right_container{padding:0 0 0 7px}#${wrapperId}_sponsored_by_wrapper{font-size:14px;line-height:16px;padding:0 14px 0 0}#${wrapperId}_text{font-size:18px;line-height:24px;padding:7px 14px 3px 0}}`;
        const sharedStyles = `@font-face{font-family:BerninoSansNarrowSemibold;src:url(https://assets.ilcdn.fi/BerninoSans-Web-NarrowSemibold.woff2) format("woff2"),url(https://assets.ilcdn.fi/BerninoSans-Web-NarrowSemibold.woff) format("woff"),url(https://assets.ilcdn.fi/BerninoSans-Web-NarrowSemibold.ttf) format("ttf"),url(https://assets.ilcdn.fi/BerninoSans-Web-NarrowSemibold.eot) format("eot")}@font-face{font-family:BerninoSansNarrowBold;src:url(https://assets.ilcdn.fi/BerninoSans-Web-NarrowBold.woff2) format("woff2"),url(https://assets.ilcdn.fi/BerninoSans-Web-NarrowBold.woff) format("woff")}#${wrapperId}{font-family:BerninoSansNarrowSemibold;cursor:pointer; clear: both}#${wrapperId}_content_wrapper{width:100%;background-color:#fff1f1}.${wrapperId}_sizing{box-sizing:border-box;display:flex}#${wrapperId}_img_wrapper{max-width:95px;max-height:95px;margin:7px;flex:6;overflow:hidden;padding-bottom:95px;position:relative}#${wrapperId}_img{width:100%;height:95px;left:-35px;min-width:180%;position:absolute}#${wrapperId}_right_container{flex:14;min-width:0}#${wrapperId}_sponsored_by_wrapper{font-family:BerninoSansNarrowBold;font-size:11px;color:#ff0000;min-height:20px;padding:0 7px 0 0;margin-top:10px;text-transform:uppercase;line-height:13px}#${wrapperId}_text{font-family:BerninoSansNarrowSemibold;word-wrap:break-word;padding:7px 7px 3px 0;text-decoration:none;font-size:16px;line-height:18px}@media only screen and (min-width:768px){#${wrapperId}_img_wrapper{max-width:120px;max-height:120px;padding-bottom:120px}#${wrapperId}_img{width:100%;height:120px;left:-45px}#${wrapperId}_right_container{padding:0 0 0 7px}#${wrapperId}_sponsored_by_wrapper{font-size:14px;line-height:16px;padding:0 14px 0 0}#${wrapperId}_text{font-size:18px;line-height:24px;padding:7px 14px 3px 0}}`;
        nativeCss = isLongform ? longformSharedStyles : sharedStyles;
        // RAHA
        if (primaryCategory === "raha") {
            // Change text color value
            nativeCss = nativeCss.replaceAll("#ff0000", "#32bdef");
            // Change background-color value
            nativeCss = nativeCss.replaceAll("#fff1f1", "#e5f6fc");
            // TERVEYS
        }
        else if (primaryCategory === "terveys") {
            // Change text color value
            nativeCss = nativeCss.replaceAll("#ff0000", "#ff8200");
            // Change background-color value
            nativeCss = nativeCss.replaceAll("#fff1f1", "#fff2e5");
            // HYVÄ OLO
        }
        else if (primaryCategory === "hyvaolo") {
            // Change text color value
            nativeCss = nativeCss.replaceAll("#ff0000", "#fa4947");
            // Change background-color value
            nativeCss = nativeCss.replaceAll("#fff1f1", "#ffebeb");
            // TYYLICOM
        }
        else if (primaryCategory === "tyylicom") {
            // Change text color value
            nativeCss = nativeCss.replaceAll("#ff0000", "#000000");
            // Change background-color value
            nativeCss = nativeCss.replaceAll("#fff1f1", "#e8e8e8");
            // ASUMINEN
        }
        else if (primaryCategory === "asuminen") {
            // Change text color value
            nativeCss = nativeCss.replaceAll("#ff0000", "#15ad9d");
            // Change background-color value
            nativeCss = nativeCss.replaceAll("#fff1f1", "#e7f7f5");
            // PERHE
        }
        else if (primaryCategory === "perhe") {
            // Change text color value
            nativeCss = nativeCss.replaceAll("#ff0000", "#6ab283");
            // Change background-color value
            nativeCss = nativeCss.replaceAll("#fff1f1", "#f0f7f2");
            // PIPPURI
        }
        else if (primaryCategory === "pippuri") {
            // Change text color value
            nativeCss = nativeCss.replaceAll("#ff0000", "#be1522");
            // Change background-color value
            nativeCss = nativeCss.replaceAll("#fff1f1", "#f5ecec");
            // MATKAILU
        }
        else if (primaryCategory === "matkailu") {
            // Change text color value
            nativeCss = nativeCss.replaceAll("#ff0000", "#0084b4");
            // Change background-color value
            nativeCss = nativeCss.replaceAll("#fff1f1", "#e9f4f8");
            // DIGI
        }
        else if (primaryCategory === "digi") {
            // Change text color value
            nativeCss = nativeCss.replaceAll("#ff0000", "#4d626c");
            // Change background-color value
            nativeCss = nativeCss.replaceAll("#fff1f1", "#edeff0");
        }
        return `${nativeCss}`;
    },
    attachClick: attachClickTracker,
};
export default simaRectangle;
//# sourceMappingURL=sima-rectangle.js.map